import React, { useState, useMemo, useRef, useEffect } from 'react';
import S from 'StyledRegisterWizardForm.js';
import {bindActionCreators} from 'redux';
import RegisterWizardFormStep1 from 'RegisterWizardFormStep1.js';
import RegisterWizardFormStep2 from 'RegisterWizardFormStep2.js';
import { translation, triggerNativeEvent, redirect } from 'helpers/utilsHelper.js';
import { getPromoCookie, setGoogleDataLayerCookie } from 'cookiesHelper.js';
import { getBtagCookie } from 'helpers/cookiesHelper.js';
import { SubmissionError, reset, change, submit, formValueSelector } from 'redux-form';
import { preregisterUser, registerUser, verificationCode } from 'authActions.js';
import { useDispatch } from 'react-redux';
import { substractYears } from 'datesHelper.js'
import ModalOpacity from 'ModalOpacity.js';
import {connect} from 'react-redux';
import usePrevious from 'UsePrevious.js';
import CmsPage from 'CmsPage.js';
import useToggle from 'UseToggle.js'
import _pick from 'lodash/pick';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _size from 'lodash/size';
import store from 'store';
import {addIncomeAccessData, setIncomeAccessIframe} from 'integrationActions.js';
import { fetchPromoCodeSetting } from 'topMenuActions.js';
import { loadPublicRegConsents } from 'customerActions.js';
import BellIcon from 'bell-icon.svg';

const StepLiner = ({ step, goToPrevPage  }) => {
    return (
        <S.StepsLineWrapper>
            <div className={step === 1 ? 'stepsContainer stepOneActive' : 'stepsContainer stepTwoActive'}>
                <div className="step stepOne">
                    <div className="stepNumber" onClick={goToPrevPage}>1</div>
                </div>
                <div className="separator"></div>
                <div className="step stepTwo">
                    <div className="stepNumber">2</div>
                </div>
            </div>
            <div className="stepsTitles">
                <div>{translation('account_registerForm_step1')}</div>
                <div>{translation('account_registerForm_step2')}</div>
            </div>
        </S.StepsLineWrapper>
    )
};

const RegisterWizardForm = (props) => {
    const {smsVerificationCode, personalIdentifier, selectAll, fetchPromoCodeSetting, isPromoCodeVisible, marketingConsent, loadPublicRegConsents} = props;
    const [step, setNextStep] = useState(1);
    const [showConfirmationModal, toggleConfirmationModal] = useToggle(false);
    const [showMarketingConsentModal, toggleMarketingConsentModal] = useToggle(false);
    const dispatch = useDispatch();
    const prevFirstStepValues = usePrevious({smsVerificationCode, personalIdentifier});
    const incomeAccessIframeRef = useRef();
    const prevStep = usePrevious(step);
    // const prevSelectAllVal = usePrevious(selectAll);
    const [affiliateParam, setAffiliateParam] = useState(null);
    const customerRegStepTwoTag = 'CUSTOMER_REGISTRATION_STEP_2';
    const [registrationConsents, setRegConsents] = useState([]);

    const toggleRegistrationTag = (addTag, tagName) => {
        const loc = window.location;
        if (addTag) {
            history.replaceState(null, null, `#${tagName}`);
        } else {
            if ('pushState' in history) {
                history.replaceState({}, document.title, loc.href.substr(0, loc.href.length - loc.hash.length));
            }
        }
    };

    useEffect(() => {
        toggleRegistrationTag(true, 'registerStart');
    }, []);

    useEffect(() => {
        fetchPromoCodeSetting();
        getPublicRegConsents().then(data => setRegConsents(data)); 
    }, []);

    useEffect(() => {
        const {dispatch} = store;
        if (step == 1 && step != prevStep) {
            setTimeout(() => {
                dispatch(change('registerForm', 'password', ''))
            }, 500);
        } else if (step == 2 && step != prevStep) {
            if (prevFirstStepValues.personalIdentifier){
                triggerNativeEvent('[name="personalIdentifier"]', 'blur');
            }
            if (prevFirstStepValues.smsVerificationCode){
                triggerNativeEvent('[name="verificationCode"]', 'blur');
            }
        }
    }, [step]);

    //read btag query param and call CMS place with banner based on it
    useEffect(() => {
        const btagParam = getBtagCookie();
        let firstPartBtagParam = btagParam?.split("b")[0];
        firstPartBtagParam = firstPartBtagParam?.replace('_', '');
        firstPartBtagParam = firstPartBtagParam ? firstPartBtagParam : 'default';
        setAffiliateParam(firstPartBtagParam);
    }, []);

    const getPublicRegConsents = async() => {
        try {
            const data = await loadPublicRegConsents(customerRegStepTwoTag);
            return data.CUSTOMER_REGISTRATION_STEP_2 || [];
        } catch (error) {
            throw error;
        }
    };

    const registerFirstStep = async (values) => {

        const {dispatch} = store;
        const pickedValues = ['email', 'marketingConsent', 'mobile', 'previousMobileNumber'];
        const registerData = _pick(values, pickedValues);
        const marketingConsentInner = _get(registerData, ['marketingConsent']);
        const previousMobileNumber = _get(registerData, ['previousMobileNumber']);
        try {

            if (marketingConsentInner == true) {
                await dispatch(preregisterUser(registerData));
            }

            const mobile = _pick(values, ['mobile']);
            if (mobile.mobile != previousMobileNumber) {
                await dispatch(change("registerForm","previousMobileNumber",mobile.mobile));
                dispatch(verificationCode(mobile));
            }

            goToNextPage();

        } catch (error) {
            throw new SubmissionError({_error: error});
        } 
        
    };

    const handleSubmitOnClick = async () => { // method to check if marketingConsent is true and if not modal will appear

        const {dispatch} = store;

        if(marketingConsent === true){
            await dispatch(submit('registerForm'));
        }else{
            toggleMarketingConsentModal(); 
        }
    }

    const handleButtonClick = async (marketingConsent = false) => { //buttons in marketing consent dialog
        const {dispatch} = store;
        await dispatch(change("registerForm","marketingConsent", marketingConsent)); 
        await dispatch(submit('registerForm'));
        toggleMarketingConsentModal(); 
    }

    const registerOnSubmit = async (postData) => {
        try {
            const newUser = await dispatch(registerUser(postData));
            return newUser;
        } catch (error) {
            throw error;
        }
    };

    const registerSecondStep = async (values) => {
        try {

            let pickedValues = [
                'firstName',
                'lastName',
                'nationality',
                'password',
                // 'isBonus',
                'email',
                'mobile',
                // 'marketingConsent',
                'verificationCode'
            ];

            const nationalityPL = _get(values, ['nationality']);
            if (nationalityPL == 'PL') {
                pickedValues = [...pickedValues, 'personalIdentifier'];
            } else {
                pickedValues = [...pickedValues, 'dateOfBirth', 'address', 'postalCode'];
            }

            const fieldPromoCode = _get(values, ['promoCode']);

            if (fieldPromoCode){
                pickedValues = [...pickedValues, 'promoCode'];
            }

            let registerData = _pick(values, pickedValues);
            if ('personalIdentifier' in registerData) {
                registerData['personalIdentificationNumber'] = registerData['personalIdentifier'];
                delete registerData['personalIdentifier'];
            }


            const emailVerification = _get(values, ['emailVerification']);
            if(emailVerification){
                registerData['verificationCode'] = null;
            }

            // opis działania w tasku 80019 - działanie na prośbę klienta przeczy wszelkiej logice
            const promoCode = getPromoCookie();
            if(!isPromoCodeVisible && promoCode){
                registerData['promoCode'] = promoCode;
            } else if (!promoCode && !fieldPromoCode) {
                registerData['promoCode'] = app.config.defaultPromoCode;
            }

            registerData.countryCode = process.env.MAIN_COUNTRY_CODE;
            registerData.currencyCode = process.env.MAIN_CURRENCY_CODE;

            registerData = addIncomeAccessData(registerData);

            const btag = registerData.affiliateId;
            if (btag){ 
                registerData['btag'] = btag;
                registerData = _.omit(registerData, 'affiliateId');
            }

            const offerContainers = [];
            for(let i in registrationConsents){
              offerContainers.push({
                "container": "OFFERS", "accepted": _get(values, ['isBonus']), "definitionId": registrationConsents[i].definitionId
              })
            }

            registerData['consents'] = [
                { "container": "LOTTERY_PARTICIPATION", "accepted": false },
                { "container": "REGULATIONS", "accepted": true },
                ...offerContainers
            ];

            const marketingConsent = _get(values, ['marketingConsent']);
            if (marketingConsent) {
                registerData['consents'].push(
                    { "container": "EMAIL", "accepted": marketingConsent },
                    { "container": "SMS", "accepted": marketingConsent },
                )
            } else if (emailVerification) {
                registerData['consents'].push(
                    { "container": "EMAIL", "accepted": true },
                    { "container": "SMS", "accepted": false },
                )
            } else {
                registerData['consents'].push(
                    { "container": "EMAIL", "accepted": false },
                    { "container": "SMS", "accepted": true },
                )
            }

            //temporary solution for my affiliate token
            const myAffiliateToken = Cookies.get('myAffiliateToken');
            if (myAffiliateToken) registerData['affiliateToken'] = myAffiliateToken;

            const customerId = await registerOnSubmit(registerData);
            await setIncomeAccessIframe(customerId, incomeAccessIframeRef);

            if (customerId) {
                 setGoogleDataLayerCookie(customerId);
            }

            toggleRegistrationTag(true, 'registerEnd');

            if(!emailVerification){
                const loginData = _pick(values, ['password']);
                loginData['login'] = _get(_pick(values, ['email']), ['email']);
                await app.component.LoginForm.loginRequest(loginData);
                resetWizardForm()
            } else {
                toggleConfirmationModal();
            }
        } catch (error) {
            throw new SubmissionError({ _error: error });
        }
    };

    const goToNextPage = () => {
        setNextStep((prevStep) => prevStep + 1);
    };

    const goToPrevPage = () => {
        if (step > 1) setNextStep((prevStep) => prevStep - 1);
    };

    const initialValuesStepTwo = useMemo(() => {
        const date = substractYears(new Date(), 18);
        let data = {
            isBonus: true,
            dayOfBirth: date.getDate(),
            monthOfBirth: date.getMonth(),
            yearOfBirth: date.getFullYear(),
            nationality: process.env.MAIN_COUNTRY_CODE
        };

        const promo = getPromoCookie();
        promo? data['promoCode'] = promo : data['promoCode'] = app.config.defaultPromoCode

        return data;
    }, []);

    const resetWizardForm = () => {
        dispatch(reset("registerForm"))
        redirect('/');
    }

    const onConfirmationCloseClick = () => {
        toggleConfirmationModal()
        resetWizardForm()
    }

    return (
        <S.RegisterWizardForm>
            <ModalOpacity isOpen={showConfirmationModal}
                toggleOpen={toggleConfirmationModal}
                title="Confirmation"
                showHeader={false}
                padding={0}>
                <S.ConfirmationModal>
                    <S.ConfirmationMsg>{translation('account_unloggedPanel_confirmationModal')}</S.ConfirmationMsg>
                    <S.ConfirmationCloseBtn
                        onClick={onConfirmationCloseClick}>{translation('common_ok')}</S.ConfirmationCloseBtn>
                </S.ConfirmationModal>
            </ModalOpacity>

            { affiliateParam && <CmsPage name={`affiliate-${affiliateParam}`} alternativeContent="affiliate-default" isPlaces={true}/> }
            
            <S.RegisterWizardFormTitle>{translation('account_registerForm_title')}</S.RegisterWizardFormTitle>
            <StepLiner step={step} goToPrevPage={goToPrevPage}/>
            
            {/* MARKETING CONSENT ACCEPTATION MODAL */}
            <ModalOpacity isOpen={showMarketingConsentModal}
                          showHeader={false}
                          showCloseIcon={false}
                          padding={0}
                          >
                <S.Modal>
                    <div className="confirm-modal-content">
                        <S.BellIcon dangerouslySetInnerHTML={{__html: BellIcon}}></S.BellIcon>                     
                        <S.ModalText data-translation="registerForm_marketingConsent_additionalText">{translation('registerForm_marketingConsent_additionalText')}</S.ModalText>                       
                        <div className="buttonsWrapper">
                            <S.ModalButton onClick={()=>{handleButtonClick(true)}} data-translation="registerForm_marketingConsent_buttonAccept">{translation('registerForm_marketingConsent_buttonAccept')}</S.ModalButton>
                            <S.ModalButton cancel onClick={()=>{handleButtonClick(false)}} data-translation="registerForm_marketingConsent_buttonCancel">{translation('registerForm_marketingConsent_buttonCancel')}</S.ModalButton>
                        </div>
                    </div>
                </S.Modal>
            </ModalOpacity>

            {step === 1 && (
                <RegisterWizardFormStep1 
                    onSubmit={registerFirstStep} 
                    handleSubmitOnClickCustom={handleSubmitOnClick}
                />
            )}
            {step === 2 && (
                <RegisterWizardFormStep2
                    initialValues={initialValuesStepTwo}
                    goToPrevPage={goToPrevPage}
                    onSubmit={registerSecondStep}
                    isPromoCodeVisible= {isPromoCodeVisible}
                />
            )}
            <S.HideIframe ref={incomeAccessIframeRef}></S.HideIframe>
        </S.RegisterWizardForm>
    )
};

const selector = formValueSelector('registerForm');
const mapStateToProps = (state) => {
   const {TopMenu:{ isPromoCodeVisible }} = state;
   return {
       personalIdentifier:  selector(state, 'personalIdentifier'),
       smsVerificationCode:  selector(state, 'verificationCode'),
       marketingConsent:  selector(state, 'marketingConsent'),
       isPromoCodeVisible
    };
};

const mapDispatchToProps = (dispatch) => {
    const bindedActions = {
      fetchPromoCodeSetting,
      loadPublicRegConsents
    }

    return {
      ...bindActionCreators(bindedActions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterWizardForm);